import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const BenefitsSection = styled.section`
  padding: 120px 24px 80px;
  background-color: ${colors.lightGray};
  scroll-margin-top: 80px; /* 헤더 높이만큼 여백 추가 */
`;

const BenefitsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 64px;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
`;

const SectionSubtitle = styled.p`
  font-size: 18px;
  color: ${colors.textGray};
  max-width: 600px;
  margin: 0 auto;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
`;

const BenefitCard = styled.div`
  background-color: ${colors.white};
  border-radius: 8px;
  padding: 32px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const BenefitIcon = styled.div`
  width: 64px;
  height: 64px;
  background-color: rgba(0, 196, 113, 0.1);
  color: ${colors.secondary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 32px;
`;

const BenefitTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${colors.primary};
`;

const BenefitDescription = styled.p`
  font-size: 16px;
  color: ${colors.textGray};
`;

const Benefits = () => {
  const benefitsData = [
    {
      icon: '🤖',
      title: 'AI 기반 바이브코딩',
      description: 'Microsoft Copilot, Cursor, Claude 등 최신 AI 도구를 활용한 효율적인 개발 방법을 학습하며, 실제 서비스 수준의 프로젝트를 구현합니다.'
    },
    {
      icon: '🚀',
      title: '자동화된 개발 환경',
      description: 'GitHub Actions를 통한 CI/CD 파이프라인, Firebase 호스팅 등 현대적인 개발 및 배포 환경을 구축하고 운영하는 방법을 배웁니다.'
    },
    {
      icon: '👨‍💻',
      title: '현업 개발자 멘토링',
      description: '대기업, 스타트업 등 다양한 현장에서 활약하는 현업 개발자들의 생생한 경험과 지식을 직접 전수받습니다.'
    },
    {
      icon: '📈',
      title: '맞춤형 성장 트랙',
      description: '개인별 학습 속도와 목표에 맞춘 커리큘럼으로 효율적인 성장을 지원합니다. 포기하지 않고 끝까지 목표를 달성할 수 있습니다.'
    },
    {
      icon: '🏆',
      title: '실무형 프로젝트',
      description: '넷플릭스, 에어비앤비, 디즈니플러스와 같은 실제 서비스 수준의 프로젝트를 구현하며 실무 경험을 쌓습니다.'
    },
    {
      icon: '🔍',
      title: '코드 리뷰 문화',
      description: 'AI 코드 리뷰 도구와 동료, 멘토의 리뷰를 통해 더 나은 코드를 작성하는 방법을 배우고 협업 능력을 키웁니다.'
    },
    {
      icon: '📚',
      title: '자격증 취득 지원',
      description: '정보처리기사, SQLD 등 취업에 유리한 자격증 취득을 위한 특별 커리큘럼과 자료를 제공합니다.'
    },
    {
      icon: '🤝',
      title: '커뮤니티 네트워킹',
      description: '같은 목표를 가진 동료들과 함께 성장하며 개발자 커뮤니티 네트워크를 형성할 수 있습니다.'
    }
  ];

  return (
    <BenefitsSection id="benefits">
      <BenefitsContainer>
        <SectionHeader>
          <SectionTitle>ElectroWave Club의 특별함</SectionTitle>
          <SectionSubtitle>
            AI 시대에 걸맞은 현대적인 개발 방식과 차별화된 교육 경험을 제공합니다
          </SectionSubtitle>
        </SectionHeader>
        
        <BenefitsGrid>
          {benefitsData.map((benefit, index) => (
            <BenefitCard key={index}>
              <BenefitIcon>{benefit.icon}</BenefitIcon>
              <BenefitTitle>{benefit.title}</BenefitTitle>
              <BenefitDescription>{benefit.description}</BenefitDescription>
            </BenefitCard>
          ))}
        </BenefitsGrid>
      </BenefitsContainer>
    </BenefitsSection>
  );
};

export default Benefits;